'use strict';

angular.module('randomization')
    .factory('RandomizationBlocksService', ['ShareCrfSDK', function RandomizationBlocksService(ShareCrfSDK) {
        var RandomizationBlocksService = {
            list: ShareCrfSDK.randomization.getBlocks,
            getBlock: function(blockId) {
                return ShareCrfSDK.randomization.getBlock({id: blockId});
            },
        };

        return RandomizationBlocksService;
    }]);
